import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef, useState } from 'react';
import { Text, Box, Link as CoreLink, slugify } from '@miro-site/core';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Title = styled(CoreLink).attrs(function (props) {
  return {
    $mb: props.theme.header.secondaryNavigation.item.margins.afterTitle,
    $styles: _objectSpread({}, props.theme.header.secondaryNavigation.item.title.styles)
  };
}).withConfig({
  displayName: "SecondaryNavigationItem__Title",
  componentId: "sc-2kc2vg-0"
})([""]);
var Description = styled(Text).attrs(function (props) {
  return {
    as: 'p',
    $styles: _objectSpread({}, props.theme.header.secondaryNavigation.item.description.styles)
  };
}).withConfig({
  displayName: "SecondaryNavigationItem__Description",
  componentId: "sc-2kc2vg-1"
})([""]);
var Wrapper = styled(Box).attrs(function (_ref) {
  var _hoverStyles;

  var $isFocused = _ref.$isFocused,
      _ref$theme = _ref.theme,
      focus = _ref$theme.focus,
      item = _ref$theme.header.secondaryNavigation.item;
  var visibleAnimation = {
    opacity: 1,
    transform: 'scale(1)',
    transition: item.hover.animation.show
  };
  var hoverStyles = (_hoverStyles = {}, _defineProperty(_hoverStyles, Title, item.title.hoverStyles), _defineProperty(_hoverStyles, Description, item.description.hoverStyles), _hoverStyles);
  return {
    $styles: _objectSpread({
      display: 'block',
      position: 'relative',
      marginTop: item.margins.before,
      marginBottom: item.margins.after,
      maxWidth: item.maxWidth,
      cursor: 'pointer',
      ':before': _objectSpread({
        position: 'absolute',
        content: "''",
        transform: 'scale(.9)',
        zIndex: -1,
        opacity: 0,
        transition: item.hover.animation.hide,
        width: "calc(100% + ".concat(item.hover.offset.left + item.hover.offset.right, "px)"),
        height: "calc(100% + ".concat(item.hover.offset.top + item.hover.offset.bottom, "px)"),
        top: "-".concat(item.hover.offset.top, "px"),
        left: "-".concat(item.hover.offset.left, "px"),
        borderRadius: item.hover.radius,
        background: item.hover.background,
        border: '1px solid transparent'
      }, $isFocused ? _objectSpread(_objectSpread({}, focus.outlines["default"]), visibleAnimation) : {}),
      ':hover': _objectSpread({
        ':before': _objectSpread({}, visibleAnimation)
      }, hoverStyles)
    }, $isFocused ? hoverStyles : {})
  };
}).withConfig({
  displayName: "SecondaryNavigationItem__Wrapper",
  componentId: "sc-2kc2vg-2"
})([""]);

var SecondaryNavigationItem = function SecondaryNavigationItem(props) {
  var title = props.title,
      description = props.description,
      path = props.path,
      className = props.className;
  var linkRef = useRef(null);
  var descriptionId = "".concat(slugify(title), "-description");

  var _useState = useState(false),
      isFocused = _useState[0],
      setFocused = _useState[1];

  var handleClick = function handleClick(e) {
    var _linkRef$current;

    if (!((_linkRef$current = linkRef.current) !== null && _linkRef$current !== void 0 && _linkRef$current.contains(e.target))) {
      var _linkRef$current2;

      (_linkRef$current2 = linkRef.current) === null || _linkRef$current2 === void 0 ? void 0 : _linkRef$current2.click();
    }
  };

  return /*#__PURE__*/_jsxs(Wrapper, {
    $isFocused: isFocused,
    className: className,
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(Title, {
      ref: linkRef,
      onFocus: function onFocus(e) {
        if (e.target === linkRef.current) {
          setFocused(true);
        }
      },
      onBlur: function onBlur() {
        return setFocused(false);
      },
      href: path,
      "aria-describedby": descriptionId,
      children: title
    }), /*#__PURE__*/_jsx(Description, {
      id: descriptionId,
      children: description
    })]
  });
};

export default SecondaryNavigationItem;